// src/router/index.js
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Login from '@/views/login/Login.vue'
import DifferentLogin from '@/views/login/DifferentLogin.vue'
import Home from '@/views/Home.vue'
import QrCodeScreen from '@/views/login/qrCodeScreen.vue'
import { clearAllCookies, clearLocalStorage, signOutApiFunc ,clearSessionStorage} from '@/common/utils'
import { getCookie } from '@hotelkeyrepo/hk-ui-utilities-vue-3/src/common/services/utilities.service';
import mutations from '@/store/mutation_types'
import store from '@/store/store'
const routes = [
  {
    path: '/',
    name: 'loginWithSlash',
    component: Login
  },
  {
    path: '/app/login',
    name: 'app-login',
    component: Login
  },
  {
    path: '/qr-code',
    name: 'qr-code',
    component: QrCodeScreen
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {requiresAuth:true}
  },
  {
    path: '/logout',
    name: 'logout'
  },
  {
    path: '/different-login',
    name: 'different-login',
    component: DifferentLogin
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

let getHistoryMode = hkConfigEnvs.VUE_APP_SET_ROUTER_STRATEGY;
if (!getHistoryMode) {
  getHistoryMode = 'hash'
}

const router = createRouter({
  history: getHistoryMode == 'hash' ? createWebHashHistory() : createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  // 📌 Declarations
  const username = getCookie('hk_logged_user');
  const token = getCookie('hk_token');
  const signedInAs = getCookie('hk_signed_in_as');
  const signoutFromAll = getCookie('signout_from_all_devices');
  const isHotelKeyDomain = signedInAs === 'hotelkeyapp.com';

  // if(to.meta.requiresAuth && !username){
  //   next({ name: 'login' })
  // }

  // 🚦 Exit early if not navigating to logout
  if (to.name !== 'logout') {
    return next();
  }

  // 🚪 Method: Redirect to homepage (fallback)
  const redirectToHome = () => {
    try { next('/') } catch (e) {
      console.error(e)
    }
  };

  // 🔒 Method: Google Sign-Out if user signed in with hotelkeyapp.com
  const handleGoogleSignOut = async () => {
    const googleSignInParams = {
      client_id: hkConfigEnvs.VUE_APP_GOOGLE_CLIENT_ID,
      hosted_domain: 'hotelkeyapp.com'
    };

    return new Promise((resolve) => {
      window.gapi.load('auth2', async () => {
        const auth2 = await window.gapi.auth2.init(googleSignInParams);
        await auth2.signOut();
        auth2.disconnect();
        resolve();
      });
    });
  };

  // 🔁 Method: Clear data and redirect
  const logoutAndRedirect = () => {
    store.commit(mutations.SET_CURRENT_TO_NULL);
    
    if (token) {
      clearLocalStorage();
      clearAllCookies();
      clearSessionStorage();
    }

    if (window.location.hostname === 'localhost') {
      return redirectToHome();
    }

    // 🔗 Build logout URL
    let logoutUrl = hkConfigEnvs.VUE_APP_LOGOUT_URL || '/';
    if (username) {
      logoutUrl += `&username=${username}&state=HK_HOME`;
    }
    if (signoutFromAll) {
      logoutUrl += '&signout_from_all_devices=true';
    }

    window.location.href = logoutUrl;
  };

  // 🧱 Step 1: If no user is logged in, redirect immediately
  if (!token) {
    return redirectToHome();
  }

  try {
    // 🧱 Step 2: Sign out of Google if domain is hotelkeyapp.com
    if (isHotelKeyDomain) {
      await handleGoogleSignOut(); // ✅ SAFE: returns a promise, awaits properly
    }

    // 🧱 Step 3: Logout from app session
    //await LoginService.logout(); // ✅ SAFE: awaited logout before redirect


    const { redirectUrl } = await signOutApiFunc({
      username,
      hk_info: store?.state?.current?.hk_info,
      cognito_login: getCookie('cognito_login') === 'true',
      token: getCookie('hk_token'),
      sessionId: getCookie('hk_session_id')
    });

    // 🧹 Step 4: Clean up storage after successful logout
    clearLocalStorage();
    clearAllCookies();
    store.commit(mutations.SET_CURRENT_TO_NULL);

    if (window.location.hostname !== 'localhost') {
      window.location.href = redirectUrl
    } else {
      next('/')
      //this.$router.push({name: cognitoLogin ? 'different-login' : "loginWithSlash"});
    }

    //window.location.href = redirectUrl;
    //clearData(status, redirectUrl);


  } catch (err) {
    console.error('Logout error:', err);
  } finally {
    // 🧭 Step 5: Redirect with full cleanup regardless of result
    logoutAndRedirect();
  }
});

export default router
